var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectronLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 111,
    viewBox: "0 0 307 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2051 75.2419H173.713L201.244 102.773H242.055",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.603 105.125C245.983 105.125 247.102 104.006 247.102 102.626C247.102 101.246 245.983 100.127 244.603 100.127C243.222 100.127 242.104 101.246 242.104 102.626C242.104 104.006 243.222 105.125 244.603 105.125Z",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H85.5077L113.039 28.531H153.849",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.397 30.8836C157.778 30.8836 158.896 29.7647 158.896 28.3845C158.896 27.0043 157.778 25.8854 156.397 25.8854C155.017 25.8854 153.898 27.0043 153.898 28.3845C153.898 29.7647 155.017 30.8836 156.397 30.8836Z",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.554 27.2075L166.282 53.479H147.87",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.604 54.8958C147.436 54.8958 148.11 54.2213 148.11 53.3894C148.11 52.5574 147.436 51.8829 146.604 51.8829C145.772 51.8829 145.097 52.5574 145.097 53.3894C145.097 54.2213 145.772 54.8958 146.604 54.8958Z",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.855 27.549C194.686 27.549 195.36 26.8749 195.36 26.0433C195.36 25.2117 194.686 24.5376 193.855 24.5376C193.023 24.5376 192.349 25.2117 192.349 26.0433C192.349 26.8749 193.023 27.549 193.855 27.549Z",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.799 82.2455L141.07 108.517H159.483",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.749 109.934C161.581 109.934 162.255 109.26 162.255 108.428C162.255 107.597 161.581 106.922 160.749 106.922C159.918 106.922 159.244 107.597 159.244 108.428C159.244 109.26 159.918 109.934 160.749 109.934Z",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.498 82.5864C114.33 82.5864 115.004 81.9122 115.004 81.0806C115.004 80.2491 114.33 79.575 113.498 79.575C112.667 79.575 111.992 80.2491 111.992 81.0806C111.992 81.9122 112.667 82.5864 113.498 82.5864Z",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6052 65.8831H201.534L216.694 50.7229H262.992L279.995 67.7261H302.735",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M304.321 69.4865C305.299 69.4865 306.091 68.6942 306.091 67.7168C306.091 66.7395 305.299 65.9471 304.321 65.9471C303.344 65.9471 302.552 66.7395 302.552 67.7168C302.552 68.6942 303.344 69.4865 304.321 69.4865Z",
    stroke: "#222532",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronLight);
export default __webpack_public_path__ + "static/media/electronLight.088bc1b02c694373bfe869dd622f0bfd.svg";
export { ForwardRef as ReactComponent };